export default {
    title: "Catalogue",
    noAvailableItems: "Aucun produit disponible à la commande."
}